<template>
    <div class="left-nav">
        <!-- <img src="@/assets/brand-icon.png" alt="" class="brandicon"> -->
        <div class="left-title">针云仓</div>
        <div class="left-desc">客户管理后台——为您构建更高效的设备管理系统</div>
        <div class="mav-list">
            <div class="navitem" v-for="item in navmap" :key="item.id" :class="{active: (active == item.id || hover == item.id)}" @mouseenter="handleMouseEnter(item)" @mouseleave="handleMouseLeave" @click="navclick(item)">
                <img :src="(active == item.id || hover == item.id) ? item.iconw : item.icong" alt="">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
import icon1g from '@/assets/icon/icon1-g.png'
import icon1w from '@/assets/icon/icon1-w.png'
import icon2g from '@/assets/icon/icon2-g.png'
import icon2w from '@/assets/icon/icon2-w.png'
import icon3g from '@/assets/icon/icon3-g.png'
import icon3w from '@/assets/icon/icon3-w.png'
import icon4g from '@/assets/icon/icon4-g.png'
import icon4w from '@/assets/icon/icon4-w.png'
import icon5g from '@/assets/icon/icon5-g.png'
import icon5w from '@/assets/icon/icon5-w.png'
import icon6g from '@/assets/icon/icon6-g.png'
import icon6w from '@/assets/icon/icon6-w.png'
import icon7g from '@/assets/icon/icon8-g.png'
import icon7w from '@/assets/icon/icon8-w.png'

export default {
    data() {
        return {
            navmap: [
                { name: '换针设备', id: 1, iconw: icon1w, icong: icon1g, url: 'home' },
                { name: '换针数据', id: 2, iconw: icon2w, icong: icon2g, url: 'change' },
                { name: '预约记录', id: 6, iconw: icon6w, icong: icon6g, url: 'record' },
                { name: '机器二维码', id: 3, iconw: icon3w, icong: icon3g, url: 'machine' },
                { name: '用户管理', id: 4, iconw: icon4w, icong: icon4g, url: 'user' },
                { name: '生产组管理', id: 5, iconw: icon5w, icong: icon5g, url: 'group' },
                { name: '工厂管理', id: 7, iconw: icon7w, icong: icon7g, url: 'scheme' },
                //{ name: '管理员设置', id: 5, iconw: icon4w, icong: icon4g, url: 'admin' },
            ],
            active: 1,
            hover: 0
        }
    },
    methods: {
        handleMouseEnter(item) {
            this.hover = item.id
        },
        handleMouseLeave() {
            this.hover = 0
        },
        navclick(item) {
            if (item.id == this.active) return
            this.$router.push(`/${item.url}`)
            this.active = item.id
        }
    },
    mounted() {
        const route = this.$route.name;
        if(route!=null){
            this.active = this.navmap.find(item => item.url == route).id
        }
    }
}
</script>

<style lang="scss" scoped>
.left-nav {
    width: 270px;
    min-width: 270px;
    background-color: #FBFBFE;
    height: 100%;
    box-shadow: 1px 0px 0px 0px #E9EBED;
    .brandicon {
        width: 70px;
        height: 70px;
        margin: 32px auto 0 72px;
    }
    .left-title {
        font-family: Source Han Sans CN;
        font-weight: 600;
        font-size: 32px;
        color: #3A3A3B;
        line-height: 31px;
        text-align: center;
        margin-top: 64px;
    }
    .left-desc {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #3A3A3B;
        line-height: 31px;
        padding: 24px 22px 36px 22px;
        border-bottom: 1px solid rgba(138, 145, 155, .2);
        text-align: center;
    }
    .mav-list {
        margin: 18px 12px 0;
        .navitem {
            width: calc(100% - 17px);
            padding: 18px 0 18px 17px;
            border-radius: 10px;
            color: #505769;
            cursor: pointer;
            margin-bottom: 5px;
            font-weight: 400;
            font-size: 18px;
            img {
                width: 22.5px;
                height: 21px;
                margin-right: 20px;
            }
            &.active {
                background: #507AF9;
                color: #fff;
            }
            &:last-child {
                margin-bottom: 0;
            }
            &:hover {
                background: #507AF9;
                color: #fff;
            }
        }
    }
}
</style>